import { createSlice } from "@reduxjs/toolkit";

const storeSlice = createSlice({
    name: "store",
    initialState: {
        storeID: null,
        storeName: null,
        storeData: null,
        productDeliveryCharge: { isEnabled: false },
        storeLotSizeEnabled: false,
        products: [],
        selectedProduct: null,
        cart: [],
        
    },
    reducers: {
        storeAllProducts: (state, action) => {
            state.products = action.payload;
        },
        setSelectedProduct: (state, action) => {
            state.selectedProduct = action.payload;
        },
        storeData: (state, action) => {
            const store = action.payload?.store?.[0] ?? action.payload;
            const { storeID, storeName, _id } = store;
            state.storeData = store;
            state.storeID = storeID;
            state.storeName = storeName;
            state._id = _id;
            state.storeLotSizeEnabled = !!(
                action.payload?.lotSize?.isEnabled ?? store?.lotSize?.isEnabled
            );
            state.productDeliveryCharge = action.payload?.productDeliveryCharge || {
                isEnabled: false,
            };
        },
        OrderDataRedux: (state, action) => {
            state.orderData = action.payload;
        },

    },
});

export const { storeAllProducts, setSelectedProduct, storeData, OrderDataRedux } = storeSlice.actions;
export default storeSlice.reducer;
